import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

const TextInput = ({
  value,
  onChange,
  onBlur, // Callback for onBlur event
  placeholder,
  defaultValue = '', // Default value initialization
  minCharacters = 0, // Minimum characters required
  maxCharacters = 1000, // Maximum characters allowed
  showComponent = true, // Toggle component visibility
}) => {
  const [inputValue, setInputValue] = useState(value || defaultValue); // Initialize with value or defaultValue
  const [characterCount, setCharacterCount] = useState(inputValue.length);
  const [focused, setFocused] = useState(false);

  // Update character count whenever the inputValue changes
  useEffect(() => {
    setCharacterCount(inputValue.length);
  }, [inputValue]);

  const handleInputChange = (e) => {
    const text = e.target.value;

    // Enforce maximum character limit
    if (text.length <= maxCharacters) {
      setCharacterCount(text.length);
      setInputValue(text);
      onChange(text);
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur(inputValue);
    }
    setFocused(false);
  };

  // Display character count and requirements
  const characterStatus = () => {
    if (characterCount < minCharacters) {
      const remaining = minCharacters - characterCount;
      return `${remaining} chars left.`;
    }
    return `${characterCount} / ${maxCharacters}`;
  };

  return (
    <div
      className={styles.inputContainer}
      style={{ display: showComponent ? 'flex' : 'none' }}
    >
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        className={`${styles.inputField} ${focused ? styles.focused : ''}`}
        onFocus={() => setFocused(true)}
      />
      <div
        className={styles.characterCount}
        style={{
          color: characterCount < minCharacters ? 'red' : 'darkgrey',
        }}
      >
        {characterStatus()}
      </div>
    </div>
  );
};

export default TextInput;
